import React from "react";
import hero from "../images/hero.png";

import { motion } from "framer-motion";
import styled from "styled-components";
import { Section, Description, Title } from "../styles";
import { titleAnim, descAnime, titleAnim2, blobAnim } from "../pageAnimation";
function AboutSection() {
  return (
    <SectionStyled>
      <Description>
        <Title>
          <motion.p variants={titleAnim} className="line-1">
            Hello, myself <span>Aryan Shinde</span>,
          </motion.p>
          <motion.p variants={titleAnim2} className="line-2">
            A Web-developer
          </motion.p>
        </Title>
        <motion.div className="heading">
          <motion.p variants={descAnime} initial="before" animate="after">
            Sophomore, Computer Science.
          </motion.p>
        </motion.div>
      </Description>
      <div className="Img">
        <motion.div
          className="blob"
          variants={blobAnim}
          initial="before"
          animate="after"
        ></motion.div>
        <motion.img src={hero} alt="meeee"></motion.img>
      </div>
      <Wave>
        <svg
          viewBox="0 0 7044 2011"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <motion.path
            initial={{ pathLength: 0, pathOffset: 1 }}
            animate={{
              pathLength: 2,
              pathOffset: 0,
              transition: {
                duration: 2,
                delay: 1,
                ease: "circInOut",
              },
            }}
            d="M14 1995C1627 530 2971 1090 3705 1339.5C5595.46 1982.1 7071 470.5 7022 2.5"
            stroke="#39374D"
            strokeWidth="24"
            stroke-opacity="0.5"
          />
        </svg>
      </Wave>
    </SectionStyled>
  );
}
const SectionStyled = styled(Section)`
  .line-1,
  .heading {
    /* margin-top: -4rem; */
  }
  .line-1,
  .line-2 {
    font-size: 2.8rem;
    font-weight: 600;
    font-family: "Sora", sans-serif;
    margin: 0;
  }

  .Img {
    position: relative;
  }

  .heading {
    font-size: 20px;
    margin-top: 1rem;
    font-family: "Montserrat", sans-serif;
    p {
      padding: 0rem 5rem 0rem 0rem;
      margin-right: 2rem;
    }
  }
  .blob {
    z-index: -2;
    top: 2%;
    left: 8%;
    content: "";
    display: flex;
    position: absolute;
    height: 20rem;
    width: 20rem;
    background-color: #8b73ff;
    border-radius: 50%;
    border: 20px solid #8b73ff;
    animation: spin 2.4s linear infinite;
    border-top: 1px solid #8b73ff;
    @media screen and (max-width: 786px) {
      width: 14rem;
      height: 14rem;
      top: 8%;
      left: 8%;
      border-top: 0.2px solid #8b73ff;
    }
  }
  @keyframes spin {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }
  @media screen and (max-width: 786px) {
    Img {
      width: 20rem;
    }
    .line-1,
    .line-2 {
      font-size: 28px;
      padding: 0;
      margin: 0;
    }
    .heading {
      font-size: 18px;
      margin: 0;
    }
  }
`;

const Wave = styled.div`
  position: absolute;
  top: 44%;
  left: 0;
  z-index: -4;
`;

export default AboutSection;
